import React, { useEffect, useRef } from 'react';
import { css } from '@emotion/react';
import { gsap, ScrollTrigger } from 'gsap/all';
import PropTypes from 'prop-types';
import { useHsHeader } from '../util/hsHeader';
import { usePreloader } from './Preloader';
import { MobileBlockWrapper } from '../styles/helpers';

gsap.registerPlugin(ScrollTrigger);

const MobileHorizontalGallery = ({ images = [] }) => {
  const carouselRef = useRef();
  const { isReady } = usePreloader();
  const [{ headerHeight }] = useHsHeader();

  useEffect(() => {
    if (!isReady) {
      return undefined;
    }

    const viewportWidth = window.innerWidth;

    const tl = gsap.timeline().to(carouselRef.current, {
      xPercent: -100,
      x: viewportWidth,
      ease: 'none',
    });

    const st = ScrollTrigger.create({
      animation: tl,
      trigger: carouselRef.current,
      pin: true,
      scrub: true,
      start: 'top top',
      end: `bottom top`,
      anticipatePin: 1,
    });

    return () => {
      tl.kill();
      st.kill();
    };
  }, [headerHeight, isReady]);

  return (
    <div
      css={css`
        white-space: nowrap;
        display: flex;
        width: 300%;
      `}
      ref={carouselRef}
    >
      {images.map(image => (
        <MobileBlockWrapper
          key={image.src}
          css={css`
            width: 100%;
          `}
        >
          <img src={image.src} alt={image.alt} />
        </MobileBlockWrapper>
      ))}
    </div>
  );
};

MobileHorizontalGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string })
  ),
};

MobileHorizontalGallery.defaultProps = {
  images: null,
};

export default MobileHorizontalGallery;
